import {
  createSlice,
  createSelector,
  createAsyncThunk,
  createEntityAdapter
} from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { AxiosResponse } from "axios";
import { API_PATH } from '../constants';
import { IInject, IInjInfo, IScheduledInjects } from '../interfaces';
import { http, httpImage } from '../utils/config';

const injectAdapter = createEntityAdapter<any>()

const initialState = injectAdapter.getInitialState()

// Thunk functions
export const fetchInjects = createAsyncThunk('inject/fetchInjects', async (scenarioId: string | null, { rejectWithValue } ) => {
  try {
    
    const response = await http.get(API_PATH + "/scenario/" + scenarioId + "/injects");

    let newData: any = {};
    newData.id = 1
    newData.injects = response.data.injects
    newData.snippets = response.data.snippets
    return newData;
  } catch (error: any) {
    if (error.response && error.response.data) {
      return rejectWithValue(error.response.data)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

// Thunk functions
export const fetchHotwashInjects = createAsyncThunk('inject/fetchHotwashInjects', async (scenarioId: string | null, { rejectWithValue } ) => {
  try {
  
    const response = await http.get(API_PATH + "/scenario/" + scenarioId + "/hotwashinjects");

    let newData: any = {};
    newData.id = 1
    newData.injects = response.data.injects
    newData.snippets = response.data.snippets
    return newData;
  } catch (error: any) {
    if (error.response && error.response.data) {
      return rejectWithValue(error.response.data)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

const injectSlice = createSlice({
    name: 'injects',
    initialState,
    reducers: {
      injectToggled(state, action) {
        //const injectId = action.payload
      },
    },
  /*extraReducers: (builder) => {
    builder
      .addCase(fetchInjects.fulfilled, (state, action) => {
        injectAdapter.setAll(state, action.payload)
      })
  }*/
})

export const {
  injectToggled
} = injectSlice.actions

export default injectSlice.reducer

export const {
  selectAll: selectInjects
} = injectAdapter.getSelectors((state: RootState) => state.injects)

export const createInjects = createAsyncThunk(
  'injects/createInjects',
  async ({ scenarioId, injects }: { scenarioId: string, injects: IScheduledInjects[] }, { rejectWithValue }) => {
    try {
      
        const response = await http.put(API_PATH + '/scenario/'+scenarioId+'/injects', { injects: injects });

        return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateInject = createAsyncThunk(
  'injects/updateInject',
  async (injInfo: IInjInfo, { rejectWithValue }) => {
    try {
      
        const response = await http.put(API_PATH + '/inject/'+injInfo.injectId+'/info', injInfo);
        return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const deleteInject = createAsyncThunk(
  'injects/deleteInject',
  async (injectId: string, { rejectWithValue }) => {
    try {
      
        const response = await http.delete(API_PATH + '/inject/' + injectId);
        return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateNodes = createAsyncThunk(
  'injects/updateNodes',
  async (createNode: any, { rejectWithValue }) => {
    try {
  
        const response = await http.put(API_PATH + '/inject/'+createNode.injectId+'/nodes', { nodes: createNode.nodes });
        return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const publishInject = createAsyncThunk(
  'injects/publishInject',
  async (id: string, { rejectWithValue }) => {
    try {

      let response: AxiosResponse<any, any> = await http.post(API_PATH + '/inject/' + id + '/publish', {});
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const fetchImages = createAsyncThunk(
  'injects/fetchImages',
  async (id: string) => {
    try {
      
      const response = await http.get(API_PATH + '/inject/' + id + '/image');
      return response.data
    } catch (error: any) {
      return error;
    }
  }
)

export const getUploadUrl = createAsyncThunk(
  'injects/uploadImages',
  async ({ injectId, fileName }: { injectId: string, fileName: string }, { rejectWithValue }) => {
    try {

      let response: AxiosResponse<any, any> = await http.post(API_PATH + '/inject/' + injectId + '/image', { fileName: fileName });
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const uploadImageFile = createAsyncThunk(
  'injects/uploadImageFile',
  async ({ imageFile, gcsUrl }: { imageFile: File, gcsUrl: string }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      //formData.append("file", imageFile);
      formData.append("data", imageFile);
      let response = await httpImage.put(gcsUrl, imageFile);
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const deleteImage = createAsyncThunk(
  'injects/deleteImage',
  async ({ injectId, fileName }: { injectId: string, fileName: string | undefined }, { rejectWithValue }) => {
    try {

      let response = await http.delete(API_PATH + '/inject/' + injectId + '/image', {data: { fileName: fileName }});
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const selectInjects1 = createSelector(
  selectInjects,
  (injects: IInject[]) => { 
    return injects.map((inject: IInject) => {
      return inject;
    })
  }
)
